module.exports = __webpack_public_path__ + "img/ctrl-pauli-x-stub-mid-0.45a69645.svg";